import React from 'react';
import PropTypes from 'prop-types';
import anime from 'animejs';

import { PRODUCT_CTA_SUBSCRIBE_CLASS } from 'ggApp/modules/tracking/constants';
import { TranslatorComponent_Text as Translator, PureTranslator } from 'ggApp/modules/translator';

import { Wrap, TextWrap, Prices, OldPrice, Price, PriceSuffix, Cta, CtaText } from './styled';

export default class ProductCta extends React.PureComponent {
    componentDidUpdate(prevProps) {
        const {
            selectedPlan: { minimumMonths },
        } = this.props;
        const {
            selectedPlan: { minimumMonths: prevMinimumMonths },
        } = prevProps;
        if (prevMinimumMonths !== minimumMonths) {
            this.bounceCta();
        }
    }

    bounceCta = () => {
        if (!this.cta) return;
        if (this.bounce) {
            this.bounce.pause();
        }
        this.bounce = anime.timeline({
            duration: 300,
            targets: this.cta,
            easing: [0, 1, 0.32, 1],
        });
        this.bounce
            .add({
                translateY: [0, -12, 0],
                easing: [0, 1, 0.32, 1],
            })
            .add({
                targets: this.cta,
                scaleX: [1, 1.05, 0.975, 1],
                scaleY: [1, 0.95, 1.025, 1],
                offset: '-=100',
            });
    };

    render() {
        const {
            className,
            price,
            oldPrice,
            selectedPlan: { minimumMonths },
            onCtaClick,
            ctaTk,
            isHidden,
            preorderProduct,
        } = this.props;
        return (
            <Wrap isHidden={isHidden} className={className}>
                <TextWrap>
                    <Prices>
                        {oldPrice && <OldPrice>{oldPrice}</OldPrice>}
                        <Price withOldPrice={!!oldPrice}>{price}</Price>
                    </Prices>
                    <PriceSuffix>
                        <Translator
                            withValues={{ duration: minimumMonths }}
                            tk="PRODUCT_CARD_PRICE_SUFFIX_MODIFIED"
                        />
                    </PriceSuffix>
                </TextWrap>
                <Cta
                    ref={(el) => {
                        this.cta = el;
                    }}
                    className={PRODUCT_CTA_SUBSCRIBE_CLASS}
                    onClick={onCtaClick}
                >
                    <CtaText>
                        <PureTranslator tk={preorderProduct ? 'PREORDER_CTA' : ctaTk} />
                    </CtaText>
                </Cta>
            </Wrap>
        );
    }
}

ProductCta.propTypes = {
    className: PropTypes.string,
    price: PropTypes.string,
    oldPrice: PropTypes.string,
    selectedPlan: PropTypes.shape({}),
    onCtaClick: PropTypes.func,
    isHidden: PropTypes.bool,
    ctaTk: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

ProductCta.defaultProps = {
    className: '',
    price: null,
    oldPrice: null,
    selectedPlan: {},
    onCtaClick: () => {},
    ctaTk: '',
    isHidden: false,
};
